/** Merge only the caller's edits into a newer review; never overwrite conflicting edits. */
const equal=(a,b)=>JSON.stringify(a??null)===JSON.stringify(b??null);
const fields=['point','text','markup','page','space'];
const content=note=>fields.map(key=>note?.[key]??null);
const conflict=()=>{throw Object.assign(new Error('同一則釋疑或設定已被更新，已保留您的草稿，請確認最新內容後再儲存'),{status:409});};
export function mergeReview(base,local,remote){
 const result=structuredClone(remote);
 for(const key of ['sourceUnit','displayUnit','scaleMeters','calibration','floors']){
  if(equal(local[key],base[key]))continue;
  if(!equal(remote[key],base[key])&&!equal(remote[key],local[key]))conflict();
  result[key]=structuredClone(local[key]);
 }
 const before=new Map(base.markers.map(m=>[m.id,m]));
 const desired=new Map(local.markers.map(m=>[m.id,m]));
 const latest=new Map(remote.markers.map(m=>[m.id,m]));
 for(const [id,old] of before){
  const next=desired.get(id),current=latest.get(id);
  if(!next){
   if(current&&(!equal(content(current),content(old))||!equal(current.workflow,old.workflow)||!equal(current.replies,old.replies)))conflict();
   result.markers=result.markers.filter(m=>m.id!==id);continue;
  }
  const changed=fields.filter(key=>!equal(next[key],old[key]));
  if(!changed.length)continue;
  if(!current)conflict();
  const merged=result.markers.find(m=>m.id===id);
  for(const key of changed){
   if(!equal(current[key],old[key])&&!equal(current[key],next[key]))conflict();
   if(next[key]===undefined)delete merged[key];else merged[key]=structuredClone(next[key]);
  }
 }
 for(const [id,note] of desired){
  if(before.has(id))continue;
  const current=latest.get(id);
  if(current){if(!equal(content(current),content(note)))conflict();}
  else result.markers.push(structuredClone(note));
 }
 // Replies and histories are server-owned; whole-review PUT must omit them.
 for(const marker of result.markers){delete marker.history;delete marker.replies;}
 return result;
}
